/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Root_Tasks_LabelInputs */

const en_explorer_root_tasks_label = /** @type {(inputs: Explorer_Root_Tasks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Tasks`)
};

const fr_explorer_root_tasks_label = /** @type {(inputs: Explorer_Root_Tasks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes taches`)
};

const de_explorer_root_tasks_label = /** @type {(inputs: Explorer_Root_Tasks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Aufgaben`)
};

const it_explorer_root_tasks_label = /** @type {(inputs: Explorer_Root_Tasks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mie attivita`)
};

const ru_explorer_root_tasks_label = /** @type {(inputs: Explorer_Root_Tasks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мои задачи`)
};

const es_explorer_root_tasks_label = /** @type {(inputs: Explorer_Root_Tasks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis tareas`)
};

const zh_cn2_explorer_root_tasks_label = /** @type {(inputs: Explorer_Root_Tasks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的任务`)
};

const ja_explorer_root_tasks_label = /** @type {(inputs: Explorer_Root_Tasks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイタスク`)
};

const hi_explorer_root_tasks_label = /** @type {(inputs: Explorer_Root_Tasks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेरे कार्य`)
};

const pt_pt2_explorer_root_tasks_label = /** @type {(inputs: Explorer_Root_Tasks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As minhas tarefas`)
};

/**
* | output |
* | --- |
* | "My Tasks" |
*
* @param {Explorer_Root_Tasks_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_root_tasks_label = /** @type {((inputs?: Explorer_Root_Tasks_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Root_Tasks_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_root_tasks_label(inputs)
	if (locale === "de") return de_explorer_root_tasks_label(inputs)
	if (locale === "it") return it_explorer_root_tasks_label(inputs)
	if (locale === "ru") return ru_explorer_root_tasks_label(inputs)
	if (locale === "es") return es_explorer_root_tasks_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_root_tasks_label(inputs)
	if (locale === "ja") return ja_explorer_root_tasks_label(inputs)
	if (locale === "hi") return hi_explorer_root_tasks_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_root_tasks_label(inputs)
	return en_explorer_root_tasks_label(inputs)
});